import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import LoginPage from './pages/auth/LoginPage'
import SignUpPage from './pages/auth/SignUpPage'
import PendingPage from './pages/auth/PendingPage'
import RejectedPage from './pages/auth/RejectedPage'
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage'
import DashboardPage from './pages/dashboard/DashboardPage'
import LessonsPage from './pages/lessons/LessonsPage'
import LessonDetailPage from './pages/lessons/LessonDetailPage'
import NearMissPage from './pages/nearmiss/NearMissPage'
import NearMissDetailPage from './pages/nearmiss/NearMissDetailPage'
import JHAPage from './pages/jha/JHAPage'
import JHADetailPage from './pages/jha/JHADetailPage'
import SafetyManualsPage from './pages/safety/SafetyManualsPage'
import EmployeeHandbookPage from './pages/safety/EmployeeHandbookPage'
import CommunicationsPage from './pages/communications/CommunicationsPage'
import ReportsPage from './pages/reports/ReportsPage'
import TimesheetsPage from './pages/timesheets/TimesheetsPage'
import CertificationsPage from './pages/certifications/CertificationsPage'
import EquipmentPage from './pages/equipment/EquipmentPage'
import TasksPage from './pages/tasks/TasksPage'
import UsersPage from './pages/users/UsersPage'
import SettingsPage from './pages/settings/SettingsPage'
import CrewMapPage from './pages/enterprise/CrewMapPage'
import IncidentsPage from './pages/incidents/IncidentsPage'
import AttendancePage from './pages/attendance/AttendancePage'
import CrewManagementPage from './pages/admin/CrewManagementPage'
import ProjectsPage from './pages/projects/ProjectsPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { currentUser, loading } = useAuth()
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full" />
      </div>
    )
  }
  if (!currentUser) {
    return <Navigate to="/login" replace />
  }
  return <>{children}</>
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/pending" element={<PendingPage />} />
          <Route path="/rejected" element={<RejectedPage />} />
          <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/lessons" element={<ProtectedRoute><LessonsPage /></ProtectedRoute>} />
          <Route path="/lessons/:id" element={<ProtectedRoute><LessonDetailPage /></ProtectedRoute>} />
          <Route path="/near-miss" element={<ProtectedRoute><NearMissPage /></ProtectedRoute>} />
          <Route path="/near-miss/:id" element={<ProtectedRoute><NearMissDetailPage /></ProtectedRoute>} />
          <Route path="/jha" element={<ProtectedRoute><JHAPage /></ProtectedRoute>} />
          <Route path="/jha/:id" element={<ProtectedRoute><JHADetailPage /></ProtectedRoute>} />
          <Route path="/safety" element={<ProtectedRoute><SafetyManualsPage /></ProtectedRoute>} />
          <Route path="/handbook" element={<ProtectedRoute><EmployeeHandbookPage /></ProtectedRoute>} />
          <Route path="/communications" element={<ProtectedRoute><CommunicationsPage /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
          <Route path="/timesheets" element={<ProtectedRoute><TimesheetsPage /></ProtectedRoute>} />
          <Route path="/certifications" element={<ProtectedRoute><CertificationsPage /></ProtectedRoute>} />
          <Route path="/equipment" element={<ProtectedRoute><EquipmentPage /></ProtectedRoute>} />
          <Route path="/tasks" element={<ProtectedRoute><TasksPage /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
          <Route path="/crewmap" element={<ProtectedRoute><CrewMapPage /></ProtectedRoute>} />
          <Route path="/incidents" element={<ProtectedRoute><IncidentsPage /></ProtectedRoute>} />
          <Route path="/attendance" element={<ProtectedRoute><AttendancePage /></ProtectedRoute>} />
          <Route path="/crew" element={<ProtectedRoute><CrewManagementPage /></ProtectedRoute>} />
          <Route path="/projects" element={<ProtectedRoute><ProjectsPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
